let PackagesItem = [
    {
        id: 1,
        trackTitle: "Full Access 🔥",
        trackSubtitle: "for experienced JavaScript Developers",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1664550129564x800031647975604200',
    },
    {
        id: 2,
        trackTitle: "Junior Track",
        trackSubtitle: "for JavaScript Developers",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Junior Track',
        trackLink: 'https://geekle.us/ticketfree/1647005390474x332743859293388800',
    },
];

export default PackagesItem;
